import { SubmitState } from '@n2-common/components/MultiStageOnePageWizard/types';
import React from 'react';
import styles from './style.module.scss';
import { Box } from '@n2-common/myPagesUi/components/box/Box';
import { Loader } from '@n2-common/myPagesUi/components/loader/Loader';
import { Status } from '@n2-common/myPagesUi/components/status/Status';
import { createPortal } from 'react-dom';
export type SubmitProgressBoxProps = {
    state: SubmitState;
    submitText: string;
    processingText: string;
};
export type SubmitProgressBoxCombinedProps = SubmitProgressBoxProps;

export function SubmitProgressBox({ state, submitText, processingText }: SubmitProgressBoxCombinedProps): JSX.Element {
    switch (state) {
        case 'NotSent':
        case 'Done':
        case 'TimedOut':
        case 'Error':
            return <></>;
        case 'Submitted':
            return createPortal( <Status message={submitText} />, document.body);
        //    return <ProgressBox headline={submitText}>{children}</ProgressBox>;
        case 'Processing':
            return createPortal( <Status message={processingText} />, document.body);
         //   return <ProgressBox headline={processingText}>{children}</ProgressBox>;
    }
    return <></>;
}

type ProgressBoxProps = {
    headline: string;
};
type ProgressBoxCombinedProps = React.PropsWithChildren & ProgressBoxProps; 

export function ProgressBox({ headline, children }: ProgressBoxCombinedProps): JSX.Element {
    return (
        <div data-nameforuitesting="progressbox" className={styles.background}>
          <div className={styles.popup}> 
            <Box padding='none' type="whiteShadow" >
                <div className={styles.innerWrapper}>
                    <div>
                        <h1>{headline}</h1>
                        {children}
                    </div>
                    <div>
                        <Loader />
                    </div>
                </div>
            </Box>
            </div>
        </div>
    );
}
